// extracted by mini-css-extract-plugin
export default {"loginContainer":"LoginPage_loginContainer__16liH","loginForm":"LoginPage_loginForm__h1CZ5","formGroup":"LoginPage_formGroup__bZHdl","authLink":"LoginPage_authLink__8AO25"};